import { deleteReq, post, put } from "../../service/api";

export const createProductType = (body) =>
  post("/reference/productType", body, true);

export const updateProductType = (id, body) =>
  put(`/reference/productType/${id}`, body);

export const deleteProductType = (id) =>
  deleteReq(`/reference/productType/${id}`);
